export default __webpack_public_path__ + "static/media/city.1a922e5e.png";